import type { TranslationKey } from '@/hooks/useTranslation';
import { KEYS } from '@/utils/constants/keys';
import { driver, Driver, Config } from 'driver.js';
import type { StepsProps } from '../territorialDashboard/guide/steps';

interface StepsDriverProps {
  t: (key: TranslationKey) => string;
  isMobile: boolean;
  steps: (props: StepsProps) => Config['steps'];
}

export const guideDriver = ({ t, steps, isMobile }: StepsDriverProps): Driver => {
  return driver({
    showProgress: true,
    allowClose: false,
    onPopoverRender: (popover, { driver }) => {
      const activeIndex = driver.getActiveIndex();

      // Remove os botões padrões
      popover.footerButtons.innerHTML = '';

      // Função para criar botão
      const makeBtn = (text: string, className: string, cb: () => void) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.innerText = text;
        b.className = className;
        b.addEventListener('click', cb);
        popover.footerButtons.appendChild(b);
        return b;
      };

      let nextText = t('label.label.guide.step.next');

      if (activeIndex === (steps({ t, isMobile })?.length || 0) - 1) {
        nextText = t('label.label.guide.step.finish');
      }

      const finishTutorial = () => {
        driver.destroy();
        localStorage.setItem(KEYS.TERRITORIAL_DASHBOARD_TUTORIAL, 'true');
      };

      const skipTutorial = () => {
        finishTutorial();
      };

      const nextTutorial = () => {
        if (activeIndex === (steps({ t, isMobile })?.length || 0) - 1) {
          finishTutorial();
        } else {
          driver.moveNext();
        }
      };

      makeBtn(t('label.label.guide.step.skip'), 'skip-btn', () => skipTutorial());
      makeBtn(nextText, 'next-btn', () => nextTutorial());

      // Adiciona o ícone antes do título
      if (!popover.wrapper.querySelector('.custom-icon')) {
        const icon = document.createElement('div');
        icon.className = 'custom-icon';
        icon.innerHTML = `
          <img src="/img/svg/icons/school.svg" alt="icon" />
        `;

        // insere antes do título
        const title = popover.title;
        if (title && title.parentElement) {
          title.parentElement.insertBefore(icon, title);
        }
      }

      // Atualiza o texto de progresso
      const progress = popover.wrapper.querySelector('.driver-popover-progress-text');
      if (progress) {
        progress.textContent = `${t('label.label.guide.step_progress.text')} ${
          Number(activeIndex) + 1
        } ${t('label.label.guide.step_progress.separator')} ${steps({ t, isMobile })?.length}`;
      }
    },
    steps: steps({ t, isMobile }),
  });
};
